import { Button, Link } from "@nextui-org/react";

export default function Resume() {
  return (
    <>
      <Button
        size="sm"
        variant="light"
        radius="full"
        className="fixed z-50 hidden md:bottom-4 md:left-4 md:block"
      >
        <a href="files/Parker_Cai_Resume.pdf" download>
          Download
        </a>
      </Button>
      <section className="relative flex flex-col p-8 pt-16 md:h-fit md:pl-[21.7rem] md:pt-[21.2rem] lg:h-auto lg:pr-28 lg:pb-16">
        <div className="absolute left-[21rem] top-0 bottom-0 hidden w-[4px] bg-gray-300 md:block" />
        <hr className="absolute left-0 top-[8.5rem] w-full border-t border-dashed border-gray-300 md:top-[21rem]" />
        <h1 className="left-[3.5rem] top-[16.6rem] text-7xl font-light md:absolute ">
          PARKER CAI <br />
          <span className="block pl-1 text-xl font-normal">
            AIA, LEED AP BD+C <br />
            Licensed Architect <br />
            MS CS Candidate
          </span>
        </h1>
        <div className="max-w-4xl">
          <h2 className="text-4xl font-light text-foreground-500">SKILLS</h2>
          <div>
            <p className="pl-0">Languages:</p>
            <ul className="mt-1 list-none  text-foreground-500">
              <li>
                Python, C/C++, JavaScript/TypeScript, Java, SQL, Bash
              </li>
            </ul>
          </div>
          <div>
            <p className="pl-0">AI Stacks:</p>
            <ul className="mt-1 list-none  text-foreground-500">
              <li>
                PyTorch, Hugging Face, LangChain, Agent Skills, Claude Code, RAG, MCP, Llama.cpp, NLP, Transformers
              </li>
            </ul>
          </div>
          <div>
            <p className="pl-0">Robotics & Computer Vision:</p>
            <ul className="mt-1 list-none  text-foreground-500">
              <li>
                OpenCV, ROS2, LeRobot, SLAM, CNN, YOLO, GAN, Diffusion, Jetson, Raspberry Pi
              </li>
            </ul>
          </div>
          <div>
            <p className="pl-0">Frontend:</p>
            <ul className="mt-1 list-none  text-foreground-500">
              <li>
                HTML/CSS, Tailwind, React, Next.js, Three.js
              </li>
            </ul>
          </div>
          <div>
            <p className="pl-0">Backend:</p>
            <ul className="mt-1 list-none  text-foreground-500">
              <li>
                Node, Express, Django, FastAPI, Flask, Streamlit
              </li>
            </ul>
          </div>
          <div>
            <p className="pl-0">Cloud & Databases:</p>
            <ul className="mt-1 list-none  text-foreground-500">
              <li>
                AWS (S3, EC2, Lambda, SQS, SNS, CDK, DynamoDB), PostgreSQL, MongoDB, Vercel
              </li>
            </ul>
          </div>
          <div>
            <p className="pl-0">Design & 3D Modeling:</p>
            <ul className="mt-1 list-none  text-foreground-500">
              <li>
                Blender, Rhino3D, Autodesk AEC Collection, Adobe Creative Suite, Figma
              </li>
            </ul>
          </div>
          <div>
            <p className="pl-0">Version Control:</p>
            <ul className="mt-1 list-none  text-foreground-500">
              <li>
                Git, GitHub, GitLab, Perforce
              </li>
            </ul>
          </div>
          <br />
          <h2 className="text-4xl font-light text-foreground-500">
            EXPERIENCE
          </h2>
          <div>
            <h3 className="font-normal text-foreground-500">
              JAN 2025 - PRESENT
            </h3>
            <Link href="https://www.northeastern.edu" isExternal>
              <h3 className="text-bold text-xl font-semibold">Northeastern University</h3>
            </Link>
            <p className="pl-0">Graduate Teaching Assistant - CS5001: Intensive Foundations of Computer Science</p>
            <ul className="mt-1 list-none  text-foreground-500">
              <li>
                Led weekly labs for a 40+ student cohort over a 14-week semester, translating core CS lecture topics into practical, hands-on exercises through live demos and guided coding exercises
              </li>
              <li>
                Graded 250+ submissions with detailed code review feedback; set up shared grading trackers and templates with 3 instructors to keep rubrics consistent across sections
              </li>
              <li>
                Held office hours and provided async help in Python, data structures, and algorithms; gave specific feedback that improved average lab grades after midterm
              </li>
            </ul>
          </div>
          <div className="my-2" />
          <div>
            <h3 className="font-normal text-foreground-500">
              MAY 2023 - PRESENT
            </h3>
            <Link href="https://ova.design" isExternal>
              <h3 className="text-bold text-xl font-semibold">OVA.DESIGN</h3>
            </Link>
            <p className="pl-0">Co-Founder - Virtual Experience Programming and Game Design</p>
            <ul className="mt-1 list-none  text-foreground-500">
              <li>
                Co-founded a digital design studio for web3 virtual experiences, operating profitably for 2+ years with repeat global clients
              </li>
              <li>
                Delivered 20+ client projects end-to-end (requirements, prototyping, production, and handoff), including a multi-year partnership with Decentraland (10+ projects)
              </li>
              <li>
                Published 10+ open-source repositories for interactive scenes, sharing reusable code and assets with the web3 developer community
              </li>
            </ul>
          </div>
          <div className="my-2" />
          <div>
            <h3 className="font-normal text-foreground-500">
              MAY 2022 - MAY 2023
            </h3>
            <Link href="https://www.gensler.com" isExternal>
              <h3 className="text-bold text-xl font-semibold">Gensler</h3>
            </Link>
            <p className="pl-0">Project Architect - Building Envelope Technical Design</p>
            <ul className="mt-1 list-none  text-foreground-500">
              <li>
                Initiated and led internal research on AI/ML tools such as Stable Diffusion, solar analysis, and parametric optimization; delivered multi-part presentations that introduced AI-driven workflows to 10+ designers
              </li>
              <li>
                Led exterior wall design and overall building geometry optimization for large-scale commercial and aviation projects (SFO T3), collaborating with multidisciplinary teams
              </li>
              <li>
                Produced 200+ facade system details and technical specifications for construction, ensuring drawings were fabrication-ready and buildable at scale
              </li>
            </ul>
          </div>
          <div className="my-2" />
          <div>
            <h3 className="font-normal text-foreground-500">
              OCT 2015 - APR 2022
            </h3>
            <Link href="https://www.som.com" isExternal>
              <h3 className="text-bold text-xl font-semibold">
                Skidmore, Owings &amp; Merrill
              </h3>
            </Link>
            <p className="pl-0">Associate, Technical Design</p>
            <ul className="mt-1 list-none  text-foreground-500">
              <li>
                Designed and built over 12 million sq ft of large-scale mixed-use, commercial, and residential high-rise projects across North America, Asia, and the Middle East
              </li>
              <li>
                Led firm-wide design research presentations through BlackBox (SOM&apos;s computational design studio) on VR/AR visualization, advanced BIM, and computational geometry optimization
              </li>
              <li>
                Served as technical lead for teams of 10+, bridging internal engineers and external clients/consultants; ran daily coordination meetings and maintained BIM models for 10+ concurrent projects
              </li>
            </ul>
          </div>
          <br />
          <h2 className="text-4xl font-light text-foreground-500">
            PROJECTS
          </h2>
          <div>
            <h3 className="font-normal text-foreground-500">
              JAN 2026 - PRESENT
            </h3>
            <Link href="https://cria.design" isExternal>
              <h3 className="text-bold text-xl font-semibold">Cria Design</h3>
            </Link>
            <p className="pl-0">Python, TypeScript, React, Vite, Three.js, R3F, RAG, MCP, NLP</p>
            <ul className="mt-1 list-none  text-foreground-500">
              <li>
                3D modeling app with AI-powered natural language commands, real-time multi-user editing, and agentic workflows
              </li>
              <li>
                Architected frontend UI with a Blender headless backend, integrating OpenRouter API to route user prompts to frontier LLMs for natural language geometry generation
              </li>
              <li>
                Built a real-time collaborative 3D editor (Figma-style) with React Three Fiber, featuring command-palette-driven interface and 3D print export (GLTF/STL/OBJ)
              </li>
            </ul>
          </div>
          <div className="my-2" />
          <div>
            <h3 className="font-normal text-foreground-500">
              DEC 2025
            </h3>
            <Link href="https://parallelai.app" isExternal>
              <h3 className="text-bold text-xl font-semibold">Parallel AI</h3>
            </Link>
            <p className="pl-0">TypeScript, React, Next.js, Tailwind CSS, Three.js, Vercel AI SDK, Supabase</p>
            <ul className="mt-1 list-none  text-foreground-500">
              <li>
                Multi-AI chat aggregator for benchmarking and comparing model responses side-by-side
              </li>
              <li>
                Engineered real-time parallel streaming responses from frontier model API providers (OpenAI, Anthropic, Gemini, Grok, etc.)
              </li>
              <li>
                Built full-stack user authentication, persistent chat history (PostgreSQL), with dynamic model toggling and minimal UI
              </li>
            </ul>
          </div>
          <div className="my-2" />
          <div>
            <h3 className="font-normal text-foreground-500">
              MAY 2024
            </h3>
            <Link href="https://ova.design" isExternal>
              <h3 className="text-bold text-xl font-semibold">OVA Design Website</h3>
            </Link>
            <p className="pl-0">TypeScript, React, Next.js, Tailwind CSS, Three.js, R3F</p>
            <ul className="mt-1 list-none  text-foreground-500">
              <li>
                Digital design studio CRUD website showcasing virtual architecture and 3D metaverse experiences
              </li>
              <li>
                Architected the studio&apos;s full-stack website using React, Three.js, and Next.js—resulting in a 3x+ increase in inbound client leads
              </li>
              <li>
                Integrated Sanity CMS for dynamic project management with GLB/GLTF model uploads—deployed on Vercel with automated CI/CD
              </li>
            </ul>
          </div>
          <br />
          <h2 className="text-4xl font-light text-foreground-500">EDUCATION</h2>
          <div>
            <h3 className="font-normal text-foreground-500">
              EXPECTED MAY 2027
            </h3>
            <h3 className="text-bold text-xl font-semibold">
              Northeastern University
            </h3>
            <p className="pl-0">Master of Science in Computer Science, GPA 3.9</p>
            <ul className="mt-1 list-none  text-foreground-500">
              <li>
                Courses: Discrete Structures, Object-Oriented Design, Data Structures and Algorithms, Cloud Computing, Pattern Recognition and Computer Vision
              </li>
              <li>
                Upcoming: Machine Learning, NLP, Deep Learning, Generative AI
              </li>
            </ul>
          </div>
          <div className="my-2" />
          <div>
            <h3 className="font-normal text-foreground-500">
              AUG 2010 - MAY 2015
            </h3>
            <h3 className="text-bold text-xl font-semibold">
              Illinois Institute of Technology
            </h3>
            <p className="pl-0">Bachelor of Architecture (5-year NAAB-accredited degree)</p>
            <ul className="mt-1 list-none  text-foreground-500">
              <li>
                Specialized in building information modeling, parametric design, and digital fabrication
              </li>
              <li>
                Awards: IIT Dean&apos;s Award for Interprofessional Project, Samuel Horwitz Memorial Scholarship
              </li>
            </ul>
          </div>
          <br />
          <h2 className="text-4xl font-light text-foreground-500">
            LICENSES
          </h2>
          <div>
            <p className="pl-0">
              The American Institute of Architects Member (AIA)
            </p>
            <p className="pl-0">State of Illinois Registered Architect (RA)</p>
            <p className="pl-0">
              LEED Accredited Professional BD+C
            </p>
          </div>
        </div>
      </section>
    </>
  );
}

